/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState, useMemo, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-cube'
import { EffectCube } from 'swiper/modules'
import PropTypes from 'prop-types'
import { Button, Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function RotateCubePreview({ srcs, setSrcs }) {
  const [key, setKey] = useState(0)
  const validImages = useMemo(() => srcs.filter((src) => src.file), [srcs])
  const [imageUrls, setImageUrls] = useState([])
  const swiperRef = useRef(null)
  const lastScrollTop = useRef(0)

  useEffect(() => {
    if (imageUrls.length > 0) {
      setKey((prev) => prev + 1)
    }
  }, [imageUrls.length])

  useEffect(() => {
    if (!validImages.length) return

    const newUrls = validImages.map((src) =>
      src.file instanceof Blob || src.file instanceof File
        ? URL.createObjectURL(src.file)
        : src.file
    )

    if (JSON.stringify(newUrls) !== JSON.stringify(imageUrls)) {
      setImageUrls(newUrls)
    }

    return () => {
      setTimeout(() => {
        newUrls.forEach((url) => {
          if (typeof url === 'string' && url.startsWith('blob:')) {
            // URL.revokeObjectURL(url)
          }
        })
      }, 500)
    }
  }, [validImages, imageUrls])

  useEffect(() => {
    const handleScroll = (event) => {
      const currentScroll = event.target.scrollTop
      const scrollDiff = Math.abs(currentScroll - lastScrollTop.current)

      if (scrollDiff >= 125 && swiperRef.current) {
        if (currentScroll > lastScrollTop.current) {
          swiperRef.current.slideNext()
        } else {
          swiperRef.current.slidePrev()
        }
        lastScrollTop.current = currentScroll
      }
    }

    const scroller = document.querySelector('.scroller-hide')
    if (scroller) {
      scroller.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (scroller) {
        scroller.removeEventListener('scroll', handleScroll)
      }
    }
  }, [])

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '5%' }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      <div className="cube-container">
        {validImages.length > 0 && (
          <Button className="close-btn" title="此按鈕僅供展示">
            ✕
          </Button>
        )}

        <Swiper
          effect="cube"
          grabCursor
          cubeEffect={{
            shadow: false,
            slideShadows: false,
            shadowOffset: 0,
            shadowScale: 0,
          }}
          pagination
          loop
          modules={[EffectCube]}
          className="mySwiper"
          onSwiper={(swiper) => {
            swiperRef.current = swiper
          }}
        >
          {imageUrls.map((src, idx) => (
            <SwiperSlide key={idx} style={{ width: '230px', height: '150px' }}>
              <div className="image-wrapper">
                <img className="cube-item" src={src || ''} alt="" />
                <CIIcon right="9%" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div style={{ position: 'relative', paddingTop: '1rem' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

RotateCubePreview.defaultProps = {
  setSrcs: () => {},
}

RotateCubePreview.defaultProps = {
  setSrcs: () => {},
}
RotateCubePreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
        PropTypes.string,
      ]),
      label: PropTypes.string,
    })
  ).isRequired,
  setSrcs: PropTypes.func,
}

export default RotateCubePreview
